import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { theme } from '@styles'
import { StatusTicketEnum, TicketAssignment } from '@types'

import { FlexRow } from '../StyledComponents'

interface StatusTicketProps {
  status?: StatusTicketEnum | TicketAssignment
  children?: ReactNode // Agrega esta líne
}

const StatusTicket: React.FC<StatusTicketProps> = ({ status, children }) => {
  const { t } = useTranslation()

  return (
    <FlexRow
      style={{
        backgroundColor: status ? theme.statusTicketColor[status] : 'transparent',
        width: '100%',
        padding: '0.5rem',
        fontWeight: 'bold',
        gap: '0.5rem',
      }}
    >
      <span>{`${t('globals.generics.statusTitle')}:`}</span>
      <span>{`${t(
        `globals.generics.status.${status ? status.toLowerCase() : 'unknown'}`,
      ).toUpperCase()}`}</span>
      {children}
    </FlexRow>
  )
}

export default StatusTicket
